import type { Ticker } from '@cutr/constants/cutlist-theme.ts';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

type LiveEvent<T> = {
  type: string;
  payload: T;
};

const EVENT_HANDLERS: Record<string, ((data: LiveEvent<unknown>) => void)[]> = {
  cutlist_upload_file_processed: [],
};

function handleMessage(event: MessageEvent) {
  const data = JSON.parse(event.data) as LiveEvent<unknown>;
  const handlers = EVENT_HANDLERS[data.type];
  if (!handlers) return;
  handlers.forEach((fn) => fn(data));
}

export const liveUpdates = {
  source: null as EventSource | null,

  connect(token: string, source: Ticker) {
    this.disconnect();

    const url = new URL('/v2/cutlist/live-updates', baseUrl);
    url.searchParams.set('token', token);
    url.searchParams.set('source', source);

    this.source = new EventSource(url.toString());
    this.source.addEventListener('message', handleMessage);
    this.source.addEventListener('error', (e) => {
      console.error('live-updates connection error', e);
    });
  },

  disconnect() {
    this.source?.close();
    this.source = null;
  },

  handleEvent<T = unknown>(
    event: string,
    fn: (data: LiveEvent<T>) => void
  ): () => void {
    if (!EVENT_HANDLERS[event]) {
      EVENT_HANDLERS[event] = [];
    }

    EVENT_HANDLERS[event].push(fn as (data: LiveEvent<unknown>) => void);

    return () => {
      EVENT_HANDLERS[event] = EVENT_HANDLERS[event].filter((f) => f !== fn);
    };
  },
};
